import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './assets/css/style.scss';

function SliderPartners() {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 4, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
  };

  return (
    <div className="section section--partners">
      <Carousel
        responsive={responsive}
        className="slider slider--partners"
        autoPlay={true}
        infinite={true}
        autoPlaySpeed={0}
        transitionDuration={20000}
        customTransition="all 20s linear"
        arrows={false}
        draggable={false}
      >
        <div className="slider__item">
          <img
            loading="lazy"
            src="https://img.icons8.com/?size=100&id=zxTyUmFYTpKN&format=png&color=000000"
            alt="Landing Page Feature Marquee Icon"
            className="slider__item-image"
          />
          <div className="slider__item-text">500+ Qytete</div>
        </div>
        <div className="slider__item">
          <img
            loading="lazy"
            src="https://img.icons8.com/?size=100&id=t0pRVC1Kipju&format=png&color=000000"
            alt="Landing Page Feature Marquee Icon"
            className="slider__item-image"
          />
          <div className="slider__item-text">50+ Shtete</div>
        </div>
        <div className="slider__item">
          <img
            loading="lazy"
            src="https://img.icons8.com/?size=100&id=59220&format=png&color=ffffff"
            alt="Landing Page Feature Marquee Icon"
            className="slider__item-image"
          />
          <div className="slider__item-text">180,000+ Pjesëmarrës</div>
        </div>
        <div className="slider__item">
          <img
            loading="lazy"
            src="https://img.icons8.com/?size=100&id=zxTyUmFYTpKN&format=png&color=000000"
            alt="Landing Page Feature Marquee Icon"
            className="slider__item-image"
          />
          <div className="slider__item-text">500+ Qytete</div>
        </div>
        <div className="slider__item">
          <img
            loading="lazy"
            src="https://img.icons8.com/?size=100&id=t0pRVC1Kipju&format=png&color=000000"
            alt="Landing Page Feature Marquee Icon"
            className="slider__item-image"
          />
          <div className="slider__item-text">50+ Shtete</div>
        </div>
        <div className="slider__item">
          <img
            loading="lazy"
            src="https://img.icons8.com/?size=100&id=59220&format=png&color=ffffff"
            alt="Landing Page Feature Marquee Icon"
            className="slider__item-image"
          />
          <div className="slider__item-text">180,000+ Pjesëmarrës</div>
        </div>
      </Carousel>
    </div>
  );
}

export default SliderPartners;
